import uspqrpRoutes from './uspqrp';
import providerRoutes from './provider';
import alert from './alert.route';
import operations from './operations.route';
import support from './support/index';
import helpdesk from './helpdesk';
import medicaid from './medicaid';

const routes = [
  {
    name: '',
    path: '/',
    meta: {
      authorization: {
        authenticated: true,
      },
    },
    component: () => import('@/components/layout/TheDynamicLayout.vue'),
    children: [
      {
        path: '/',
        name: '',
        component: () => import('@/views/home/Home.vue'),
      },
      ...uspqrpRoutes,
      ...providerRoutes,
      ...alert,
      ...operations,
      ...support,
      ...helpdesk,
      ...medicaid,
    ],
  },
  {
    path: '*',
    redirect: { name: '' },
  },
];

export default routes;
